export const removeConsoleLogs = () => {
    if (process.env.NODE_ENV === 'production') {
        const originalConsoleLog = console.log;
        console.log = () => { };
        return () => {
            console.log = originalConsoleLog;
        };
    } else {
        return () => { };
    }
};